<template>
    <div class=" flex align-items-center justify-content-center mt-2">
        <Card class=" w-9">
            <template #content>
                <div class="grid">
                    <div class="col-12">
                        <div class="align-self-center" style="flex: 1">
                            <Skeleton width="100%" class="mb-4"></Skeleton>
                            <Skeleton width="75%" class="mb-4"></Skeleton>
                            <Skeleton width="50%"></Skeleton>
                        </div>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4">
                        <div class="grid">
                            <div class="col-6 flex flex-wrap align-items-center justify-content-center">
                                <ProgressSpinner style="width: 100px; height: 100px" strokeWidth="8"
                                    animationDuration=".5s" aria-label="Custom ProgressSpinner" />
                            </div>
                            <div class="col-6 flex flex-wrap align-items-center justify-content-center">
                                <div class="text-5xl font-semibold vertical-align-middle">Yükleniyor...</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-12">
                        <div class="flex justify-content-end flex-wrap" style="flex: 1">
                            <Skeleton width="50%" class="mb-4"></Skeleton>
                            <Skeleton width="75%" class="mb-4"></Skeleton>
                            <Skeleton width="100%"></Skeleton>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
export default {
    data() { return {}; },
    methods: {},
    mounted() { },
    components: {},
};
</script>